import { ActionIcon, ActionIconProps, Tooltip } from '@mantine/core'
import React from 'react'

const IconButton = ({
  label,
  onClick,
  icon,
  disabled,
  styles,
}: {
  label: string
  onClick: () => void
  icon: React.ReactNode
  disabled?: boolean
  styles?: ActionIconProps['styles']
}) => {
  return (
    <Tooltip key="import" label={label} arrowOffset={10} position="top" withArrow>
      <ActionIcon size={36} variant="default" aria-label="Import" onClick={onClick} disabled={disabled} styles={styles}>
        {icon}
      </ActionIcon>
    </Tooltip>
  )
}

export default IconButton
